/* ============================================================
   TITÁN Blindaje 360 — "NUEVAS BOTAS CAT WORK" (slug 'titan'). Rediseño 2026-07-07.
   Producto Shopify: "COMBO SEG REFLECTIVA & GORRA CAT + CAJA" (8578718498977).
   Selección COLOR × TALLA → variante (mapa window.TITAN_VARIANTS). PRECIO ÚNICO,
   sin combos (qty siempre 1). Galería por color (window.TITAN_GAL). Los .js-checkout
   disparan el modal Releasit COD. OJO: color "cafe" (landing) = "MARRON" (Shopify).
   NO usar _rsiV2.setState como primer path. Ver memory/project_bundles_as_variants.
   ============================================================ */

(function () {
  var VARIANTS = window.TITAN_VARIANTS || {};   // "NEGRO|40" -> variantId
  var GAL = window.TITAN_GAL || {};             // "gris" -> asset url
  var COLOR_MAP = { gris: 'GRIS', amarillo: 'AMARILLO', cafe: 'MARRON', negro: 'NEGRO', azul: 'AZUL' };

  var selColor = 'gris';
  var selTalla = '37';

  var galMain = document.getElementById('galMain');
  var satcImg = document.getElementById('satcImg');
  var thumbs = document.querySelectorAll('.thumb');
  var colorPills = document.querySelectorAll('#colores .pill');

  function setColor(c) {
    if (GAL[c]) { if (galMain) galMain.src = GAL[c]; if (satcImg) satcImg.src = GAL[c]; }
    thumbs.forEach(function (t) { t.classList.toggle('active', t.dataset.c === c); });
    colorPills.forEach(function (p) { p.classList.toggle('active', p.dataset.c === c); });
    selColor = c;
    titanSync();
  }
  thumbs.forEach(function (t) { t.addEventListener('click', function () { setColor(t.dataset.c); }); });
  colorPills.forEach(function (p) { p.addEventListener('click', function () { setColor(p.dataset.c); }); });

  var tallasBox = document.getElementById('tallas');
  if (tallasBox) {
    tallasBox.addEventListener('click', function (e) {
      if (!e.target.classList.contains('pill')) return;
      tallasBox.querySelectorAll('.pill').forEach(function (p) { p.classList.remove('active'); });
      e.target.classList.add('active');
      selTalla = e.target.textContent.trim();
      titanSync();
    });
  }

  /* ---------- variante activa ---------- */
  function currentVariantId() {
    var key = (COLOR_MAP[selColor] || (selColor || '').toUpperCase()) + '|' + selTalla;
    return VARIANTS[key] || null;
  }
  function titanSetVariantOnAllForms(variantId) {
    if (!variantId) return;
    document.querySelectorAll('form[action="/cart/add"] input[name="id"]').forEach(function (i) { i.value = variantId; });
    document.querySelectorAll('input[name="product-id"]').forEach(function (i) { i.value = variantId; });
    document.querySelectorAll('input[name="quantity"]').forEach(function (i) { i.value = '1'; i.setAttribute('value', '1'); });
    if (window.productData) { window.productData.quantity = 1; }
    if (window.productData && Array.isArray(window.productData.variants)) {
      var v = window.productData.variants.find(function (x) { return String(x.id) === String(variantId); });
      if (v) {
        window.productData.selected_or_first_available_variant = v;
        window.productData.selected_variant = v;
        try {
          document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: v } }));
          document.dispatchEvent(new CustomEvent('product:variant-change', { detail: { variant: v } }));
        } catch (e) {}
      }
    }
  }
  function titanSync() { titanSetVariantOnAllForms(currentVariantId()); }
  window.titanSync = titanSync;

  /* ---------- Releasit COD ---------- */
  var RELEASIT_SELECTORS = ['#rsi_buy_now_button', '.rsi_buy_now_button', '._rsi-buy-now-button', '._rsi-buy-now-button-app-block-hook button', '._rsi-buy-now-button-app-block-hook a', '.rsi-btn-skel'];
  function findReleasit() {
    for (var i = 0; i < RELEASIT_SELECTORS.length; i++) { var el = document.querySelector(RELEASIT_SELECTORS[i]); if (el) return el; }
    return null;
  }
  function titanTriggerCOD() {
    var vid = currentVariantId();
    if (!vid) { alert('Por favor elige color y talla.'); return; }
    titanSetVariantOnAllForms(vid);
    setTimeout(function () {
      var b = findReleasit();
      if (b) { b.click(); return; }
      var n = 0;
      var poll = setInterval(function () {
        n++;
        var bb = findReleasit();
        if (bb) { clearInterval(poll); bb.click(); return; }
        if (n > 30) { clearInterval(poll); if (window._rsiV2 && typeof window._rsiV2.setState === 'function') { try { window._rsiV2.setState({ isOpen: true }); } catch (e) {} } }
      }, 100);
    }, 50);
  }
  window.titanTriggerCOD = titanTriggerCOD;
  document.querySelectorAll('.js-checkout').forEach(function (b) {
    b.addEventListener('click', function (e) { e.preventDefault(); titanTriggerCOD(); });
  });

  /* ---------- fechas de entrega dinámicas ---------- */
  try {
    var fmt = function (d) { return d.toLocaleDateString('es-CO', { month: 'short', day: 'numeric' }); };
    var hoy = new Date();
    var d2a = new Date(hoy); d2a.setDate(hoy.getDate() + 1);
    var d2b = new Date(hoy); d2b.setDate(hoy.getDate() + 2);
    var d3a = new Date(hoy); d3a.setDate(hoy.getDate() + 3);
    var d3b = new Date(hoy); d3b.setDate(hoy.getDate() + 6);
    var e1 = document.getElementById('d1'), e2 = document.getElementById('d2'), e3 = document.getElementById('d3');
    if (e1) e1.textContent = fmt(hoy);
    if (e2) e2.textContent = fmt(d2a) + ' – ' + fmt(d2b);
    if (e3) e3.textContent = fmt(d3a) + ' – ' + fmt(d3b);
  } catch (e) {}

  /* ---------- carrusel testimonios ---------- */
  var slides = document.querySelectorAll('.t-slide');
  var dots = document.querySelectorAll('.t-dot');
  var ti = 0;
  function tGo(n) {
    ti = n % slides.length;
    slides.forEach(function (s, i) { s.classList.toggle('on', i === ti); });
    dots.forEach(function (d, i) { d.classList.toggle('on', i === ti); });
  }
  dots.forEach(function (d, i) { d.addEventListener('click', function () { tGo(i); }); });
  if (slides.length) setInterval(function () { tGo(ti + 1); }, 5000);

  /* ---------- countdown 10:00 loop ---------- */
  var secs = 600;
  var cd = document.getElementById('cd');
  if (cd) setInterval(function () {
    secs = secs > 0 ? secs - 1 : 600;
    var m = String(Math.floor(secs / 60)).padStart(2, '0');
    var s = String(secs % 60).padStart(2, '0');
    cd.textContent = m + ':' + s;
  }, 1000);

  /* ---------- videos play/pausa según viewport ---------- */
  var vio = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) e.target.play().catch(function () {}); else e.target.pause(); });
  }, { rootMargin: '150px 0px' });
  document.querySelectorAll('video.lazyv').forEach(function (v) { vio.observe(v); });

  /* ---------- sticky ATC ---------- */
  var satc = document.getElementById('satc');
  var prod = document.querySelector('.producto');
  function upSatc() {
    if (!satc || !prod) return;
    satc.classList.toggle('show', window.scrollY > prod.offsetTop + prod.offsetHeight * 0.55);
  }
  window.addEventListener('scroll', upSatc, { passive: true });
  upSatc();

  /* ---------- init ---------- */
  titanSync();
})();
